'use strict';

function _Routes() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_Paths];

  this.init = function () {};
  this.initAllReady = function () {};

  this.getRouteObj = function (url) {
    // remove trailing "/"
    if (url[url.length - 1] === '/') {
      url = url.substr(0, url.length - 1);
    }
    // remove hash
    return this._routes[url];
  };
  this.getDefaultView = function () {
    return '/member/dashboard/home';
  };

  this._routes = {
    '/member/dashboard/verify-account': {
      primary: 'account/verify-account-email',
      page_config: {
        page_name: 'account verification'
      }
    },

    /* New OnBoarding Experience */

    // Identity Verification
    // '/member/dashboard/onboarding/product-interests': {
    //   tray: 'account/onboarding/product-interests'
    // },
    // '/member/dashboard/onboarding/credit-request': {
    //   tray: 'account/onboarding/credit-request'
    // },
    // '/member/dashboard/onboarding/legal-name': {
    //   tray: 'account/onboarding/legal-name'
    // },
    // '/member/dashboard/onboarding/dob': {
    //   tray: 'account/onboarding/dob'
    // },
    '/member/dashboard/onboarding/address': {
      tray: 'account/onboarding/address'
    },
    // '/member/dashboard/onboarding/phone': {
    //   tray: 'account/onboarding/phone'
    // },

    // step 1
    '/member/dashboard/profile-info': {
      tray: 'account/onboarding/create-profile-step1',
      class: 'portal--no-padding default-no-theme',
      page_config: {
        page_name: 'onboarding profile info'
      }
    },
    // step 2
    '/member/dashboard/onboarding/create-profile': {
      tray: 'account/profile-info-step2',
      class: 'portal--no-padding default-no-theme',
      page_config: {
        page_name: 'onboarding create profile'
      }
    },

    // // Pre-approval decision
    '/member/dashboard/onboarding/residential-status': {
      tray: 'account/onboarding/residential-status'
    },
    '/member/dashboard/onboarding/residential-details': {
      tray: 'account/onboarding/residential-details'
    },
    // Pre-approval: Employment / Income
    '/member/dashboard/onboarding/employment-information': {
      tray: 'account/onboarding/employment-information'
    },
    // Consent / Terms & Conditions
    '/member/dashboard/onboarding/provide-consent': {
      tray: 'account/onboarding/provide-consent',
      class: 'portal--no-padding default-no-theme'
    },

    '/member/dashboard/kyc-questions': {
      tray: 'account/kyc-questions',
      class: 'portal--no-padding',
      page_config: {
        page_name: 'onboarding kyc questions'
      }
    },
    '/member/dashboard/declined/underage': {
      primary: 'account/declined-underage'
    },
    '/member/dashboard/declined/province': {
      primary: 'account/declined-province'
    },
    '/member/dashboard/declined/province-underage': {
      primary: 'account/declined-province-underage'
    },
    '/member/dashboard/declined/kyc-denied': {
      primary: 'account/declined-kyc-denied'
    },
    '/member/dashboard/declined/kyc-failed': {
      primary: 'account/declined-kyc-failed'
    },
    '/member/dashboard/declined/profile-not-found': {
      primary: 'account/profile-not-found'
    },
    '/member/dashboard/declined/kyc-first-attempt': {
      tray: 'account/declined-kyc-first-attempt'
    },
    '/member/dashboard/declined/kyc-last-attempt': {
      primary: 'account/declined-kyc-last-attempt'
    },
    // Equifax Outage: Full Tray
    '/member/dashboard/kyc-partner-down': {
      tray: 'account/kyc-partner-down',
      class: 'portal--no-padding verification',
      page_config: {
        page_name: 'onboarding kyc unavailable error'
      }
    },
    '/member/dashboard/account-already-exists': {
      primary: 'account/account-already-exists'
    },
    '/member/dashboard/unrecoverable-error': {
      primary: 'account/unrecoverable-error'
    },
    '/member/dashboard/soft-credit-check': {
      tray: 'account/credit-check',
      class: 'portal--no-padding',
      page_config: {
        page_name: 'onboarding soft credit check'
      }
    },
    '/member/dashboard/licence-info': {
      tray: 'account/licence-info',
      class: 'portal--no-padding'
    },
    '/member/dashboard/loans/licence-info': {
      trayside: 'loans/preapproval/tray-reup',
      tray: 'loans/preapproval/loan-offer-reup-licence',
      subnav: 'loans/preapproval/subnav',
      class: 'money'
    },
    '/member/dashboard/home/interstitial': {
      primary: 'home/interstitial'
    },
    '/member/dashboard/home/interstitial-crypto-referral': {
      primary: 'home/interstitial-crypto-tiers-referral'
    },
    '/member/dashboard/rewards/cashback': {
      primary: 'crypto/rewards-cashback-view',
      trayside: 'crypto/rewards',
      class: 'portal--rewards-cashback-view',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/home': {
      primary: 'home/dashboard',
      trayside: 'home/tray-promo-banner',
      class: 'portal--tray-small-hide portal--tray-medium-hide portal--tray-no-scroll portal--tray-darkside'
    },
    '/member/dashboard/home/notification-centre': {
      primary: 'home/dashboard',
      trayside: 'home/tray-notification-centre',
      class: 'portal--modal portal--notification-centre'
    },
    '/member/dashboard/home/referral-panel': {
      primary: 'home/dashboard',
      trayside: 'home/tray-referral-panel',
      class: 'portal--modal portal--referral-panel'
    },
    '/member/dashboard/account/phone-verification': {
      tray: 'account/phone-verification'
    },
    '/member/dashboard/account/change-email': {
      tray: 'account/change-email'
    },
    '/member/dashboard/account/change-email-verified': {
      tray: 'account/change-email'
    },
    '/member/dashboard/account/change-email-unverified': {
      tray: 'account/change-email-unverified'
    },
    // - Has new format address - Update it (https://mogofintech.atlassian.net/browse/ACCT-596)
    '/member/dashboard/account/change-address-update': {
      tray: 'account/change-address-update'
    },
    // - Does not have new format address - Create it (https://mogofintech.atlassian.net/browse/ACCT-596)
    '/member/dashboard/account/change-address-create': {
      tray: 'account/change-address-create'
    },
    '/member/dashboard/account/change-consent': {
      tray: 'account/change-consent'
    },
    '/member/dashboard/account/link-bank': {
      tray: 'account/link-bank'
    },
    '/member/dashboard/account/edit-bank': {
      tray: 'account/edit-bank'
    },
    '/member/dashboard/account/link-bank-offline-bank': {
      tray: 'account/link-bank-offline-bank'
    },
    '/member/dashboard/account/link-bank-not-supported-bank': {
      tray: 'account/link-bank-not-supported-bank'
    },

    /* Loans */

    // Dashboard (Router)
    '/member/dashboard/loans': {
      primary: 'loans/router',
      class: 'money'
    },

    '/member/dashboard/loans/interstitial': {
      primary: 'loans/interstitial'
    },

    // Dashboard (Preapproval)
    '/member/dashboard/loans/preapproval': {
      primary: 'loans/preapproval/dashboard',
      class: 'portal--live-chat money js--loader-enabled',
      toptray: 'loans/dashboard/tabnav',
      page_config: {
        defer_page_load_completed: true
      }
    },

    // Paid off loan - no offer - refresh
    '/member/dashboard/loans/paid-off': {
      primary: 'loans/preapproval/paid-off',
      class: 'portal--live-chat money'
    },

    // Re-up preapproval
    '/member/dashboard/loans/request': {
      trayside: 'loans/preapproval/tray-reup',
      subnav: 'loans/preapproval/subnav-tray',
      class: 'money portal--modal'
    },
    '/member/dashboard/loans/request/additional-info': {
      trayside: 'loans/preapproval/tray-reup',
      tray: 'loans/preapproval/loan-offer-additional-info',
      subnav: 'loans/preapproval/subnav',
      class: 'money'
    },
    '/member/dashboard/loans/request/review-info': {
      trayside: 'loans/preapproval/tray-reup',
      tray: 'loans/preapproval/loan-offer-reup-review',
      subnav: 'loans/preapproval/subnav',
      class: 'money'
    },
    '/member/dashboard/loans/request/select-amount': {
      trayside: 'loans/preapproval/tray-reup',
      tray: 'loans/preapproval/loan-offer-reup-request',
      subnav: 'loans/preapproval/subnav',
      class: 'money'
    },
    /*
     LOANS FLOWS
    */

    /*
      Mini Loans Flow
    */
    '/member/dashboard/loans/apply/bank-statement/verify': {
      tray: 'loans/verify-bank',
      class: 'money'
    },
    '/member/dashboard/loans/apply/bank-statement/connect': {
      tray: 'loans/link-to-loan-bank',
      class: 'money'
    },
    '/member/dashboard/loans/apply/bank-statement/error': {
      tray: 'loans/bank-error',
      class: 'money'
    },
    // New error page for when Plaid Fails in Mini Loans Flow
    // https://mogofintech.atlassian.net/browse/DV-2923
    '/member/dashboard/loans/apply/bank-statement/dlt-fallback-error': {
      tray: 'loans/dlt-fallback-error',
      class: 'money'
    },

    /*
      Loan Application Flow (DLA / Liquid)
    */
    '/member/dashboard/loans/apply': {
      primary: 'loans/application/dashboard',
      class: 'money'
    },

    '/member/dashboard/loans/application/progress': {
      primary: 'loans/application/status',
      trayside: 'loans/application/side-tray',
      subnav: 'loans/application/step-subnav',
      class: 'money portal--modal'
    },

    // This doesnt exist, is not used:
    '/member/dashboard/loans/application/incomplete': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/incomplete',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/start': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/start',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/phone-verification': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/phone-verification',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/employment': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/employment',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/income': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/income',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/income/weekly': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/income-weekly',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/income/bi-weekly': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/income-weekly',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/income/monthly': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/income-monthly',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/income/semi-monthly': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/income-semi-monthly',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/loan-customization': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/loan-customization',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/banking': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/banking',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/review': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/review',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/bank-introduction': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/bank-introduction',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/connect-bank': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/connect-bank',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/connect-to-bank-service': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/connect-to-bank-service',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/email-bank': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/email-bank',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/retrieve-bank': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/retrieve-bank',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/complete': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/complete',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/complete-error': {
      trayside: 'loans/application/side-tray',
      tray: 'loans/application/complete-error',
      subnav: 'loans/application/step-subnav',
      class: 'money'
    },

    '/member/dashboard/loans/application/status': {
      primary: 'loans/application/status',
      class: 'portal--live-chat money'
    },

    // Loan Manitoba Licenses

    '/member/dashboard/loans/manitoba-liquid-license': {
      tray: 'loans/license/manitoba-liquid-license',
      class: 'portal--no-padding money'
    },

    '/member/dashboard/loans/manitoba-mini-license': {
      tray: 'loans/license/manitoba-mini-license',
      class: 'portal--no-padding money'
    },

    // Loan Products - Liquid

    // Offers
    '/member/dashboard/loans/offers': {
      primary: 'loans/dashboard/offers',
      toptray: 'loans/dashboard/tabnav',
      class: 'money',
      page_config: {
        defer_page_load_completed: true
      }
    },

    // Educational
    '/member/dashboard/loans/educational': {
      primary: 'loans/educational',
      class: 'portal--live-chat money',
      toptray: 'loans/dashboard/tabnav'
    },

    '/member/dashboard/loans/educational/articles': {
      primary: 'loans/article-gallery',
      primaryState: 'routeOnHashChange',
      toptray: 'loans/article-subnav',
      class: 'portal--live-chat money'
    },

    // How to level up
    '/member/dashboard/loans/offers/how-to-level-up': {
      primary: 'loans/dashboard/mobile/how-to-level-up',
      class: 'money'
    },

    // Whats the process
    '/member/dashboard/loans/offers/whats-the-process': {
      primary: 'loans/dashboard/mobile/whats-the-process',
      class: 'money'
    },

    '/member/dashboard/loans/liquid': {
      primary: 'loans/product/dashboard',
      class: 'money',
      primaryState: 'liquid'
    },

    // Overview: active, paid_off, closed for Liquid
    '/member/dashboard/loans/overview': {
      primary: 'loans/dashboard/overview',
      toptray: 'loans/dashboard/tabnav',
      class: 'money liquid',
      page_config: {
        defer_page_load_completed: true
      }
    },

    '/member/dashboard/loans/liquid/questions': {
      primary: 'loans/product/liquid/questions',
      class: 'money'
    },
    '/member/dashboard/loans/liquid/add-payment': {
      primary: 'loans/product/liquid/add-payment',
      class: 'money',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/loans/liquid/add-payment/pay-in-full': {
      primary: 'loans/product/liquid/add-payment',
      trayside: 'loans/product/liquid/add-payment-full',
      class: 'money portal--modal'
    },
    '/member/dashboard/loans/liquid/add-payment/additional-payment-date': {
      primary: 'loans/product/liquid/add-payment',
      trayside: 'loans/product/liquid/add-payment-additional-date',
      class: 'money portal--modal'
    },
    '/member/dashboard/loans/liquid/add-payment/additional-payment-amount': {
      primary: 'loans/product/liquid/add-payment',
      trayside: 'loans/product/liquid/add-payment-additional-amount',
      class: 'money portal--modal'
    },
    '/member/dashboard/loans/liquid/add-payment/additional-payment-review': {
      primary: 'loans/product/liquid/add-payment',
      trayside: 'loans/product/liquid/add-payment-additional-review',
      class: 'money portal--modal'
    },
    '/member/dashboard/loans/liquid/add-payment/additional-payment-success': {
      primary: 'loans/product/liquid/add-payment',
      trayside: 'loans/product/liquid/add-payment-additional-success',
      class: 'money portal--modal'
    },
    '/member/dashboard/loans/liquid/add-payment/additional-payment-failed': {
      primary: 'loans/product/liquid/add-payment',
      trayside: 'loans/product/liquid/add-payment-additional-failed',
      class: 'money portal--modal'
    },

    // Loan Products - Mini/Zip

    '/member/dashboard/loans/mini': {
      primary: 'loans/product/dashboard',
      class: 'money',
      primaryState: 'mini'
    },
    '/member/dashboard/loans/zip': {
      primary: 'loans/product/dashboard',
      class: 'money',
      primaryState: 'zip'
    },

    // Application
    '/member/dashboard/loans/phone-verification': {
      tray: 'loans/phone-verification',
      class: 'money'
    },

    /* Crypto */

    '/member/dashboard/crypto': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      class: 'crypto js--loader-enabled',
      page_config: {
        defer_page_load_completed: true
      }
    },

    '/member/dashboard/crypto/create-account': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/create-account',
      class: 'crypto portal--modal'
    },

    // '/member/dashboard/crypto/settings': {
    //   primary: 'crypto/settings',
    //   toptray: 'crypto/tabnav',
    //   class: 'crypto'
    // },

    '/member/dashboard/crypto/educational': {
      primary: 'crypto/educational',
      toptray: 'crypto/tabnav',
      class: 'crypto'
    },

    '/member/dashboard/crypto/educational/articles': {
      primary: 'crypto/article-gallery',
      primaryState: 'routeOnHashChange',
      toptray: 'crypto/article-subnav',
      class: 'crypto'
    },
    '/member/dashboard/crypto/fund-intent-of-use': {
      tray: 'crypto/intent-of-use',
      class: 'crypto'
    },
    '/member/dashboard/crypto/fund-terms-and-conditions': {
      tray: 'crypto/terms-and-conditions',
      class: 'crypto'
    },
    '/member/dashboard/crypto/occupation': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/principal-occupation',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/occupation-select': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/principal-occupation-select',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/occupation-other': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/principal-occupation-other',
      class: 'crypto portal--modal'
    },
    // Crypto Sunset:
    // '/member/dashboard/crypto/buy': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/buy',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/buy-quote': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/buy-quote',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/buy-expire': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/buy-expire',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/buy-complete': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/buy-complete',
    //   class: 'crypto portal--modal'
    // },
    '/member/dashboard/crypto/sell': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/sell',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/sell-quote': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/sell-quote',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/sell-expire': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/sell-expire',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/sell-complete': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/sell-complete',
      class: 'crypto portal--modal'
    },
    // Crypto Sunset:
    // '/member/dashboard/crypto/fund-begin': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-begin',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/fund': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund',
    //   primaryState: 'forceDashboardReload',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/fund-etransfer': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-etransfer',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/fund-details': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-details',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/fund-wire-transfer': {
    //   primary: 'crypto/dashboard',
    //   trayside: 'crypto/fund-wire',
    //   toptray: 'crypto/tabnav',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/fund-wire-transfer-consent': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-wire-consent',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/fund-wire-details': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-details-wire',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/wire-receipt': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-wire-receipt',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/wire-receipt-info': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-wire-receipt-info',
    //   class: 'crypto portal--modal'
    // },
    // '/member/dashboard/crypto/wire-complete': {
    //   primary: 'crypto/dashboard',
    //   toptray: 'crypto/tabnav',
    //   trayside: 'crypto/fund-wire-complete',
    //   class: 'crypto portal--modal'
    // },
    '/member/dashboard/crypto/withdraw': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/withdraw',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/withdraw-confirmation': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/withdraw-confirmation',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/withdraw-complete': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/withdraw-complete',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/withdraw-error': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/withdraw-error',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/bank-required': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-required',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/crypto-transfer': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/crypto-transfer',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/crypto-transfer-coinsquare': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/crypto-transfer-coinsquare',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/crypto-transfer-coinsquare-complete': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/crypto-transfer-coinsquare-complete',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/bank-info': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-info',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/bank-info-confirm': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-info-confirm',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/bank-edit': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-info',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/bank-pending': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-pending',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/bank-confirmation': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-confirmation',
      class: 'crypto portal--modal'
    },

    '/member/dashboard/crypto/bank-error': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-error',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/crypto-transfer': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/crypto-transfer',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/crypto-transfer-coinsquare': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/crypto-transfer-coinsquare',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/crypto-transfer-coinsquare-complete': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/crypto-transfer-coinsquare-complete',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-confirmation': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-confirmation',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-info': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-info',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-info-confirm': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-info-confirm',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-required': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-required',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-edit': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-info',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-pending': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-pending',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/bank-error': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/bank-error',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/verify-bank': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/verify-bank',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/verify-bank-complete': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/verify-bank-complete',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/verify-bank-error': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/verify-bank-error',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/verify-bank': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/verify-bank',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/verify-bank-complete': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/verify-bank-complete',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/settings/verify-bank-error': {
      primary: 'crypto/settings',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/verify-bank-error',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/use-the-app': {
      primary: 'crypto/mobile'
    },
    '/member/dashboard/crypto/interstitial': {
      primary: 'crypto/interstitial'
    },
    '/member/dashboard/rewards': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/rewards',
      class: 'crypto portal--modal',
      primaryState: 'forceCryptoWatchReload',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/crypto/fund-emt': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/emt/fund-emt-amount',
      primaryState: 'forceDashboardReload',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/fund-emt-status': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/emt/fund-emt-status',
      primaryState: 'forceDashboardReload',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/fund-emt-processing': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/emt/fund-emt-processing',
      primaryState: 'forceDashboardReload',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/fund-emt-complete': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/emt/fund-emt-complete',
      primaryState: 'forceDashboardReload',
      class: 'crypto portal--modal'
    },
    '/member/dashboard/crypto/fund-emt-request': {
      primary: 'crypto/dashboard',
      toptray: 'crypto/tabnav',
      trayside: 'crypto/emt/fund-emt-request-iframe',
      primaryState: 'forceDashboardReload',
      class: 'crypto portal--modal'
    },

    /* Mortgage */

    '/member/dashboard/mortgage': {
      primary: 'mortgage/dashboard',
      toptray: 'mortgage/tabnav',
      class: 'portal--live-chat mortgage js--loader-enabled',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/mortgage/in_progress': {
      primary: 'mortgage/dashboard',
      trayside: 'mortgage/tray-create-mortgage',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/phone-verification': {
      tray: 'mortgage/phone-verification',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new': {
      primary: 'mortgage/dashboard',
      trayside: 'mortgage/tray-create-mortgage',
      subnav: 'mortgage/subnav-tray',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/options': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/mortgage-options',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/backup': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/backup',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/employment-info': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/employment-info',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/details': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/mortgage-details',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/liability': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/liability',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/consent': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/consent',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/new/submitted': {
      trayside: 'mortgage/tray-create-mortgage',
      tray: 'mortgage/submitted',
      subnav: 'mortgage/subnav',
      class: 'mortgage'
    },
    '/member/dashboard/mortgage/interstitial': {
      primary: 'mortgage/interstitial'
    },
    '/member/dashboard/mortgage/educational': {
      primary: 'mortgage/coming-soon',
      toptray: 'mortgage/tabnav',
      class: 'mortgage'
    },

    /* Credit Score */

    '/member/dashboard/credit-score': {
      primary: 'credit-score/dashboard',
      toptray: 'credit-score/tabnav',
      class: 'portal--live-chat credit-score js--loader-enabled',
      primaryState: 'view-6',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/credit-score/interstitial': {
      primary: 'credit-score/interstitial'
    },
    '/member/dashboard/credit-score/all': {
      primary: 'credit-score/dashboard',
      class: 'portal--live-chat credit-score',
      primaryState: 'view-all'
    },
    '/member/dashboard/credit-score/educational': {
      primary: 'credit-score/educational',
      toptray: 'credit-score/tabnav',
      class: 'portal--live-chat credit-score'
    },
    '/member/dashboard/credit-score/educational/articles': {
      primary: 'credit-score/article-gallery',
      primaryState: 'routeOnHashChange',
      toptray: 'credit-score/article-subnav',
      class: 'portal--live-chat credit-score'
    },

    /* Card */
    '/member/dashboard/card/load': {
      primary: 'home/dashboard',
      class: 'card portal--modal'
    },
    // Card holder views
    '/member/dashboard/card': {
      primary: 'home/dashboard',
      class: 'js--loader-enabled',
      page_config: {
        defer_page_load_completed: true
      }
    },
    // Marketing views
    '/member/dashboard/card/interstitial': {
      primary: 'card/interstitial'
    },
    '/member/dashboard/card/overview': {
      primary: 'card/overview-loader',
      class: 'portal--live-chat card',
      toptray: 'card/tabnav',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/card/educational': {
      primary: 'card/educational',
      class: 'portal--live-chat card',
      toptray: 'card/tabnav'
    },
    '/member/dashboard/card/educational/articles': {
      primary: 'card/article-gallery',
      primaryState: 'routeOnHashChange',
      toptray: 'card/article-subnav',
      class: 'portal--live-chat card',
      page_config: {
        page_name: 'card educational article'
      }
    },
    '/member/dashboard/card/walkthrough': {
      primary: 'card/walkthrough-loader',
      toptray: 'card/walkthrough-subnav'
    },
    '/member/dashboard/card/carbon-walkthrough': {
      primary: 'card/carbon-walkthrough-loader',
      toptray: 'card/walkthrough-subnav'
    },
    '/member/dashboard/card/carbon-lifetime': {
      primary: 'card/carbon-lifetime',
      class: 'portal--live-chat card',
      toptray: 'card/walkthrough-subnav'
    },
    '/member/dashboard/card/analysis': {
      primary: 'card/analysis',
      class: 'card',
      toptray: 'card/tabnav'
    },
    '/member/dashboard/card/settings': {
      primary: 'card/settings',
      class: 'portal--live-chat card',
      toptray: 'card/tabnav',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/card/activate-bitcoin-cashback': {
      primary: 'card/activate-bitcoin-cashback',
      toptray: 'card/bitcoin-cashback-subnav',
      class: 'portal--activate-bitcoin-cashback'
    },
    '/member/dashboard/card/bitcoin-cashback-lifetime': {
      primary: 'card/bitcoin-cashback-lifetime',
      toptray: 'card/bitcoin-cashback-subnav',
      class: 'portal--bitcoin-cashback-lifetime portal--live-chat card'
    },
    '/member/dashboard/card/settings/select-bank': {
      primary: 'card/settings',
      trayside: 'card/settings-select-bank',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/add-bank': {
      primary: 'card/settings',
      trayside: 'card/load-add-bank',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/add-bank-success': {
      primary: 'card/settings',
      trayside: 'card/load-add-bank-success',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/add-bank-error': {
      primary: 'card/settings',
      trayside: 'card/load-add-bank-error',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/add-bank-unsupported': {
      primary: 'card/settings',
      trayside: 'card/settings-add-bank-unsupported',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/auto-transfer': {
      primary: 'card/settings-auto-transfer',
      class: 'card'
    },
    '/member/dashboard/card/settings/auto-transfer/skip-transfer': {
      primary: 'card/settings-auto-transfer',
      trayside: 'card/settings-auto-transfer-skip',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/auto-transfer/skip-transfer-success': {
      primary: 'card/settings-auto-transfer',
      trayside: 'card/settings-auto-transfer-skip-success',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/manage-bank-account': {
      primary: 'card/settings-manage-bank-account',
      class: 'card',
      page_config: {
        defer_page_load_completed: true
      }
    },

    '/member/dashboard/card/settings/manage-bank-account/delete-success': {
      primary: 'card/settings-delete-bank-account-success',
      class: 'card'
    },

    '/member/dashboard/card/order-card': {
      primary: 'card/dashboard',
      trayside: 'card/tray-order-card',
      subnav: 'card/subnav-tray'
    },
    '/member/dashboard/card/replace-design': {
      primary: 'card/settings',
      trayside: 'card/tray-order-card',
      subnav: 'card/subnav-tray'
    },
    '/member/dashboard/card/replace-card': {
      primary: 'card/dashboard',
      trayside: 'card/tray-order-card',
      subnav: 'card/subnav-tray'
    },
    '/member/dashboard/card/order-card/out-of-stock': {
      trayside: 'card/tray-order-card',
      tray: 'card/out-of-stock',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-card/out-of-stock': {
      trayside: 'card/tray-order-card',
      tray: 'card/out-of-stock',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-design/out-of-stock': {
      trayside: 'card/tray-order-card',
      tray: 'card/out-of-stock',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/order-card/phone-verification': {
      trayside: 'card/tray-order-card',
      tray: 'card/phone-verification',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/order-card/choose-design': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-gallery',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-design/choose-design': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-gallery',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-card/choose-design': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-gallery',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/order-card/choose-design-product': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-product',
      subnav: 'card/subnav-order',
      class: 'portal--no-subnav-small-only'
    },
    '/member/dashboard/card/replace-design/choose-design-product': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-product',
      subnav: 'card/subnav-order',
      class: 'portal--no-subnav-small-only'
    },
    '/member/dashboard/card/replace-card/choose-design-product': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-product',
      subnav: 'card/subnav-order',
      class: 'portal--no-subnav-small-only'
    },
    '/member/dashboard/card/order-card/set-pin': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-set-pin',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-design/set-pin': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-set-pin',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-card/set-pin': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-set-pin',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/order-card/confirm-address': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-confirm-address',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-design/confirm-address': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-confirm-address',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-card/confirm-address': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-confirm-address',
      subnav: 'card/subnav-order'
    },

    '/member/dashboard/card/order-card/checkout': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-checkout',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-design/checkout': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-checkout',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/replace-card/checkout': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-checkout',
      subnav: 'card/subnav-order'
    },
    '/member/dashboard/card/order-card/confirmation': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-confirmation',
      subnav: 'card/subnav'
    },
    '/member/dashboard/card/replace-design/confirmation': {
      trayside: 'card/tray-order-card',
      tray: 'card/order-confirmation',
      subnav: 'card/subnav'
    },
    '/member/dashboard/card/replace-card/confirmation': {
      primary: 'card/dashboard',
      trayside: 'card/tray-order-card',
      tray: 'card/order-confirmation',
      subnav: 'card/subnav'
    },
    '/member/dashboard/card/activate': {
      primary: 'card/dashboard',
      trayside: 'card/tray-activate-card',
      subnav: 'card/subnav-tray'
    },
    '/member/dashboard/card/activate/card-id': {
      trayside: 'card/tray-activate-card',
      tray: 'card/card-id',
      subnav: 'card/subnav-activate',
      page_config: {
        page_name: 'card activate'
      }
    },
    '/member/dashboard/card/activate/pin-reminder': {
      trayside: 'card/tray-activate-card',
      tray: 'card/pin-reminder',
      subnav: 'card/subnav-activate'
    },
    '/member/dashboard/card/activate/view-pin': {
      trayside: 'card/tray-activate-card',
      tray: 'card/activate-view-pin',
      subnav: 'card/subnav-activate'
    },
    '/member/dashboard/card/activate/find-pin': {
      trayside: 'card/tray-activate-card',
      tray: 'card/activate-find-pin',
      subnav: 'card/subnav-activate'
    },
    '/member/dashboard/card/activate/confirmation': {
      trayside: 'card/tray-activate-card',
      tray: 'card/activate-confirmation',
      subnav: 'card/subnav-activate',
      class: 'portal--no-cancel'
    },
    '/member/dashboard/card/load/add-bank': {
      primary: 'card/dashboard',
      trayside: 'card/load-add-bank',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/add-bank-success': {
      primary: 'card/dashboard',
      trayside: 'card/load-add-bank-success',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/add-bank-error': {
      primary: 'card/dashboard',
      trayside: 'card/load-add-bank-error',
      class: 'card portal--modal'
    },

    '/member/dashboard/card/edit/transfer': {
      primary: 'card/settings-auto-transfer',
      trayside: 'card/load-vdtransfer',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/edit/transfer-start-date': {
      primary: 'card/settings-auto-transfer',
      trayside: 'card/load-vdtransfer-start-date',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/edit/transfer-details': {
      primary: 'card/settings-auto-transfer',
      trayside: 'card/load-vdtransfer-details',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/edit/transfer-success': {
      primary: 'card/settings-auto-transfer',
      trayside: 'card/edit-transfer-recurring-success',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer': {
      primary: 'card/dashboard',
      trayside: 'card/load-vdtransfer',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-start-date': {
      primary: 'card/dashboard',
      trayside: 'card/load-vdtransfer-start-date',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-details': {
      primary: 'card/dashboard',
      trayside: 'card/load-vdtransfer-details',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/etransfer': {
      primary: 'card/dashboard',
      trayside: 'card/load-etransfer',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/etransfer-details': {
      primary: 'card/dashboard',
      trayside: 'card/load-etransfer-details',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-success': {
      primary: 'card/dashboard',
      trayside: 'card/load-transfer-adhoc-success',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-failure': {
      primary: 'card/dashboard',
      trayside: 'card/load-transfer-adhoc-failure',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-recurring-failure': {
      primary: 'card/dashboard',
      trayside: 'card/load-transfer-recurring-failure',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-recurring-success': {
      primary: 'card/dashboard',
      trayside: 'card/load-transfer-recurring-success',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-failure-timeout': {
      primary: 'card/dashboard',
      trayside: 'card/load-time-out-error',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/settings/transfer-failure-timeout': {
      primary: 'card/settings',
      trayside: 'card/load-time-out-error',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-adhoc-failure-pending': {
      primary: 'card/dashboard',
      trayside: 'card/load-transfer-adhoc-failure-pending',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/load/transfer-incomplete': {
      primary: 'card/dashboard',
      trayside: 'card/load-transfer-adhoc-incomplete',
      class: 'card portal--modal'
    },

    '/member/dashboard/card/goal/prompt': {
      primary: 'card/dashboard',
      trayside: 'card/spending-goal-prompt',
      class: 'card portal--modal'
    },

    '/member/dashboard/card/goal/set': {
      primary: 'card/dashboard',
      trayside: 'card/spending-goal-set',
      class: 'card portal--modal'
    },
    '/member/dashboard/card/goal/confirmation': {
      primary: 'card/dashboard',
      trayside: 'card/spending-goal-confirmation',
      class: 'card portal--modal'
    },

    '/member/dashboard/card/transfer-recurring-failure': {
      primary: 'card/dashboard',
      trayside: 'card/auto-transfer-failed',
      subnav: 'card/subnav-tray',
      class: 'portal--modal'
    },

    '/member/dashboard/card/forgot-pin': {
      tray: 'card/forgot-pin',
      class: 'card',
      subnav: 'card/subnav-tray',
      page_config: {
        page_name: 'card settings forgot pin'
      }
    },
    '/member/dashboard/card/suspend-card': {
      primary: 'card/settings',
      trayside: 'card/suspend-card',
      toptray: 'card/tabnav',
      subnav: 'card/subnav-tray-settings',
      class: 'portal--modal portal--top-tray-default',
      page_config: {
        page_name: 'card settings suspend card'
      }
    },

    /* Account */

    '/member/dashboard/account': {
      primary: 'account/dashboard',
      class: 'account'
    },

    /* Wealth / mUP Template */

    '/member/dashboard/wealth': {
      primary: 'wealth/overview',
      toptray: 'wealth/tabnav',
      class: 'wealth js--loader-enabled',
      page_config: {
        defer_page_load_completed: true
      }
    },
    '/member/dashboard/wealth/interstitial': {
      primary: 'wealth/interstitial'
    },
    '/member/dashboard/wealth/educational': {
      primary: 'wealth/educational',
      toptray: 'wealth/tabnav',
      class: 'wealth'
    },
    '/member/dashboard/wealth/educational/articles': {
      primary: 'wealth/article-gallery',
      primaryState: 'routeOnHashChange',
      toptray: 'wealth/article-subnav',
      class: 'wealth'
    }
  };
}